import { jsx as _jsx } from "react/jsx-runtime";
import { useSession } from 'frontend/js/modules/infra/session';
import { useToggle } from 'frontend/js/modules/infra/small-tools/use-toggle';
import { useEngageTable } from './table/use-table';
import { EngageCampaignListView } from './list-view';
import { useBreakpoints } from '../../../../infra/dls/hooks/use-get-breakpoints';
import { getUrlPrefixFromView, useNavigate } from '../../../../infra/routing';
import { BannerType } from '../../banners';
import { useSetupEngageBanner } from '../../banners/hooks/use-setup-engage-banner';
export var EngageCampaignListContainer = function () {
    var _a = useEngageTable(), table = _a.table, isLoading = _a.isLoading, emptyTableState = _a.emptyTableState, onRowClick = _a.onRowClick, filters = _a.filters, sort = _a.sort, pagination = _a.pagination, count = _a.count;
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var session = useSession().data;
    var urlPrefix = getUrlPrefixFromView(session.view);
    var navigate = useNavigate();
    var isFiltersOpen = useToggle();
    useSetupEngageBanner({
        bannerType: BannerType.AutomatedCampaign,
        onPrimaryClick: function () { return navigate("".concat(urlPrefix, "/engagement/automated")); },
    });
    return (_jsx(EngageCampaignListView, { table: table, isLoading: isLoading, emptyTableState: emptyTableState, onRowClick: onRowClick, filters: filters, sort: sort, count: count, pagination: pagination, mobileView: isMobileOrSmaller, onOpenFilters: isFiltersOpen.setOn, isFiltersOpen: isFiltersOpen.isOn, onCloseFilters: isFiltersOpen.setOff }));
};
